export function debounceAsync(callback, wait) {
  let timeoutId = null

  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    return new Promise(resolve => {
      const timeoutPromise = new Promise(resolve => {
        timeoutId = setTimeout(resolve, wait);
      })
      timeoutPromise.then(async () => {
        resolve(await callback(...args));
      })
    })
  }
}
